import { render, staticRenderFns } from "./diretor.vue?vue&type=template&id=29a6cbec"
import script from "./diretor.vue?vue&type=script&lang=js"
export * from "./diretor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports